import * as actionTypes from "./actionTypes";

const licenseReducer = (state = [], payload) => {
  switch (payload.type) {
    case actionTypes.ADD_LICENSE_SUCCESS:
      return [...payload.licenses];

    case actionTypes.EDIT_LICENSE_SUCCESS:
      return [...payload.licenses];

    case actionTypes.DELETE_LICENSE_SUCCESS:
      return [...payload.licenses];
      
    case actionTypes.GET_LICENSES_SUCCESS:
      return [...payload.licenses];

    default:
      return state;
  }
};

export default licenseReducer;
